var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.appIsLoading)?_c('loader-component'):[(_vm.errorState)?_c('error-alert-component',{attrs:{"errorType":_vm.errorType}}):_c('router-view')]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }